import type { Intersection } from 'utility-types'

import type { CybusConnection, CybusDetailedConnection } from '../../../../../../domain'

import { isResourceOfProtocol, mapResourceName, type Resource } from '../../../../mappers'

type BaseConnection = Omit<Intersection<CybusDetailedConnection, CybusConnection>, 'status'>

export const mapBaseConnection = (resource: Resource<'Connection'>): BaseConnection => {
    const { connection } = resource.resourceConfig.args

    const baseConnection: BaseConnection = {
        id: resource.resourceId,
        name: mapResourceName(resource.resourceId),
        service: resource.serviceId,
        deviceAddress: null,
        deviceInstance: null,
        ipAddress: null,
        cncType: null,
        device: null,
        brokers: null,
        agent: resource.runnerName || null,
        host: 'host' in connection && connection.host && typeof connection.host === 'string' ? connection.host : null,
        port: 'port' in connection && connection.port && (typeof connection.port === 'string' || typeof connection.port === 'number')
            ? String(connection.port)
            : null,
    }

    if (isResourceOfProtocol(resource, 'Connection', 'ads')) {
        const { routerTcpPort } = resource.resourceConfig.args.connection
        return { ...baseConnection, port: typeof routerTcpPort === 'number' ? String(routerTcpPort) : null }
    }

    if (isResourceOfProtocol(resource, 'Connection', 'kafka')) {
        const { brokers } = resource.resourceConfig.args.connection
        return { ...baseConnection, brokers: [...brokers] }
    }

    if (isResourceOfProtocol(resource, 'Connection', 'heidenhain')) {
        const { ipAddress, cncType } = resource.resourceConfig.args.connection
        return { ...baseConnection, ipAddress: ipAddress || null, cncType: cncType || null }
    }

    if (isResourceOfProtocol(resource, 'Connection', 'bacnet')) {
        const { deviceAddress, deviceInstance } = resource.resourceConfig.args.connection
        const { host = null, port = null } = /^(?<host>.+):(?<port>[0-9]{2,5})$/.exec(deviceAddress)?.groups ?? {}
        return { ...baseConnection, deviceAddress, deviceInstance: String(deviceInstance), host, port }
    }

    return baseConnection
}
